import $ from 'jquery';
const initInfluencerShareLink = require('modules/influencer-share-link')
$(() => {
    initInfluencerShareLink();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/influencer-share-link/index.js